<div class="container-fluid">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Details</span>
  </nav>
</div>

<div class="container-fluid p-0">
  <!-- Partner users are managed by support: the form is read-only to clients. -->
  @if (profileLocked) {
    <div class="alert alert-info m-2">
      <mat-icon class="align-middle mr-2">lock</mat-icon>
      This {{ utils.getLangTerm('employees.singular', 'Employee').toLowerCase() }} is managed by {{ utils.getAppName() }}. Their details can only be changed by {{ utils.getAppName() }} support.
    </div>
  }

  <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)" [class.read-only-form]="!canEditProfile">
    <div class="card rounded-0">
      <div class="card-body">

        <div class="row pt-3">
          <div class="col-12 col-xl-6">
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Full Name</mat-label>
                  <input
                    matInput
                    placeholder="Full Name"
                    [(ngModel)]="employeeService.employee.contact_person"
                    name="contact_person"
                    type="text"
                    id="contact_person"
                    required
                    [disabled]="!canEditProfile"/>
                  <mat-hint>Enter the name of your {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Email Address</mat-label>
                  <input
                    matInput
                    placeholder="Email Address"
                    [(ngModel)]="employeeService.employee.email"
                    name="email"
                    type="email"
                    required
                    id="email"
                    [disabled]="!canEditProfile"/>
                  <mat-hint>Enter the email address of your {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6">
            <div class="row">
              <div class="col">
                <app-phone-input
                  [idInput]="mobile_input_id"
                  [numberInput]="employeeService.employee.mobile"
                  [countryCodeInput]="employeeService.employee.mobile_country_code"
                  [dialCodeInput]="employeeService.employee.mobile_dial_code"
                  [e164NumberInput]="employeeService.employee.mobile_e164"
                  (phoneDetailsOutput)="getOutputPhoneDetails($event)"
                  [labelInput]="utils.getLangTerm('users.form.mobile', 'Mobile Number')"
                  [hintInput]="'Enter the ' + utils.getLangTerm('users.form.mobile', 'Mobile Number') + ' of your ' + utils.getLangTerm('employees.singular', 'Employee') + '.'"
                  required="true"
                  [disabled]="!canEditProfile">
                </app-phone-input>
              </div>
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Job Title</mat-label>
                  <mat-select
                    matInput
                    placeholder="Job Title"
                    [(ngModel)]="employeeService.employee.trade"
                    name="trade"
                    id="trade"
                    [disabled]="!canEditProfile">
                    <mat-option *ngFor="let trade of trades" [value]="trade.name">{{ trade.name }}</mat-option>
                  </mat-select>
                  <mat-hint>Select the job title of your {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-xl-6">
            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ utils.getLangTerm('users.form.notes', 'Notes') }}</mat-label>
              <textarea
                matInput
                rows="10"
                [placeholder]="utils.getLangTerm('users.form.notes', 'Notes')"
                [(ngModel)]="employeeService.employee.pivot.notes"
                name="notes"
                id="notes"
                [disabled]="!canEditProfile">
              </textarea>
              <mat-hint>Enter {{ utils.getLangTerm('users.form.notes', 'Notes') }} for your {{ utils.getLangTerm('employees.singular', 'Employee') }}. The notes can only be seen in this active account by administrators.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-xl-6">
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Address</mat-label>
                  <input
                    matInput
                    placeholder="Address"
                    [(ngModel)]="employeeService.employee.address"
                    name="address"
                    type="text"
                    id="address"
                    [disabled]="!canEditProfile"/>
                  <mat-hint>Enter the address of your {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>{{ utils.getLangTerm('users.form.suburb', 'Suburb') }}</mat-label>
                  <input
                    matInput
                    [placeholder]="utils.getLangTerm('users.form.suburb', 'Suburb')"
                    [(ngModel)]="employeeService.employee.suburb"
                    name="suburb"
                    type="text"
                    id="suburb"
                    [disabled]="!canEditProfile"/>
                  <mat-hint>Enter the {{ utils.getLangTerm('users.form.suburb', 'Suburb') }} of your {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label> {{ utils.getLangTerm('users.form.city', 'City') }} </mat-label>
                  <input
                    matInput
                    [placeholder]="utils.getLangTerm('users.form.city', 'City')"
                    [(ngModel)]="employeeService.employee.city"
                    name="city"
                    type="text"
                    id="city"
                    [disabled]="!canEditProfile"/>
                  <mat-hint>Enter the {{ utils.getLangTerm('users.form.city', 'City') }} of your {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label> {{ utils.getLangTerm('users.form.postal_code', 'Postal Code') }} </mat-label>
                  <input
                    matInput
                    [placeholder]="utils.getLangTerm('users.form.postal_code', 'Postal Code')"
                    [(ngModel)]="employeeService.employee.postal_code"
                    name="postal_code"
                    type="text"
                    id="postal_code"
                    [disabled]="!canEditProfile"/>
                  <mat-hint>Enter the {{ utils.getLangTerm('users.form.postal_code', 'Postal Code') }} of your {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Country</mat-label>
                  <input
                    matInput
                    placeholder="Country"
                    [(ngModel)]="employeeService.employee.country"
                    name="country"
                    type="text"
                    id="country"
                    [disabled]="!canEditProfile"/>
                  <mat-hint>Enter the country of your {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            @if (canEditProfile) {
              <button
                mat-raised-button
                class="my-2 ml-0 mr-2"
                [disabled]="!f.valid || mobile_error_state"
                (click)="onSubmit(f)"
                type="submit"
                color="primary"
                id="update_button">
                <mat-icon>save</mat-icon>
                Update
              </button>
            }
          </div>
        </div>

      </div>
    </div>
  </form>
</div>
